import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DomainService {
    getDomainSettings(): Observable<any> {
        // Mock API response
        return of({
            institutionName: 'Siddaganga Institute of Technology',
            primaryDomain: 'sit.ac.in',
            allowedDomains: ['students.sit.ac.in'],
            autoEnrollment: true,
            emailVerificationRequired: true,
            defaultBatch: 'Batch A',
        });
    }

    updateDomainSettings(payload: any): Observable<any> {
        console.log('Updated settings:', payload);
        // Normally you'd use HttpClient to POST/PUT to an API
        return of({ success: true });
    }
}
